import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../styles/CodeReaderNew.css';
import VerticalSensorCard from './VerticalSensorCard';

import codeReaderImg from '../assets/product4.png';

const codeReaderData = {
  title: 'Code Reader',
  image: codeReaderImg,
  points: [
    'Inner megapixel image sensor combined with advanced decoding algorithms',
    'One-touch button setup saves debug time',
    'Supports 32 readers for networked coordination',
  ],
  link: '/products/CodeReader',
};

const CodeReaderNew = () => {
  return (
    <div className="code-reader-new-page">
      <Header />
      <div className="content-wrapper">
        <section className="code-reader-hero">
          <h1>{codeReaderData.title}</h1>
          <p>
            Explore high-performance code readers engineered for fast and
            accurate decoding in complex industrial environments.
          </p>
        </section>

        <section className="sensor-grid">
          <Link to={codeReaderData.link} className="sensor-card-link">
            <VerticalSensorCard
              image={codeReaderData.image}
              title={codeReaderData.title}
              points={codeReaderData.points}
            />
          </Link>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default CodeReaderNew;
